// extracted by mini-css-extract-plugin
export default {"container":"Archived_container__udx4X"};